export * from './update-type-cell.component';
